import { useState, useEffect } from 'react';

const slides = [
  {
    image: 'https://public.readdy.ai/ai/img_res/49c7b6b63e4c79ea8cf3777a8c50aaf7.jpg',
    title: 'Lavorazioni Meccaniche di Precisione',
    subtitle: 'Eccellenza nelle lavorazioni conto terzi per i settori edile e meccanico'
  },
  {
    image: 'https://readdy.ai/api/search-image?query=warehouse%20full%20of%20organized%20steel%20beams%20and%20iron%20construction%20materials%20for%20building%20industry%20with%20industrial%20shelving%20and%20professional%20storage%20system%20in%20bright%20modern%20facility&width=1920&height=1080&seq=hero2&orientation=landscape',
    title: 'Commercio Ferro per Edilizia',
    subtitle: 'Fornitura all\'ingrosso di materiali ferrosi di alta qualità'
  },
  {
    image: 'https://readdy.ai/api/search-image?query=impressive%20metal%20structures%20and%20steel%20frameworks%20for%20construction%20projects%20showing%20engineering%20excellence%20with%20geometric%20patterns%20and%20industrial%20architecture%20in%20professional%20setting&width=1920&height=1080&seq=hero3&orientation=landscape',
    title: 'Strutture Metalliche su Misura',
    subtitle: 'Soluzioni personalizzate per ogni esigenza costruttiva'
  }
];

export default function Hero() {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  const scrollToContact = () => {
    const element = document.getElementById('contatti');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative h-screen overflow-hidden">
      {slides.map((slide, index) => (
        <div
          key={index}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <div className="absolute inset-0">
            <img
              src={slide.image}
              alt={slide.title}
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/60"></div>
          </div>

          <div className="relative h-full flex items-center justify-center">
            <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
              <h2 className="text-5xl lg:text-7xl font-bold text-white mb-6 animate-fade-in">
                {slide.title}
              </h2>
              <p className="text-xl lg:text-2xl text-white/90 mb-10 max-w-3xl mx-auto animate-fade-in-delay">
                {slide.subtitle}
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-in-delay-2">
                <button
                  onClick={scrollToContact}
                  className="bg-gradient-to-r from-slate-700 to-slate-900 text-white px-8 py-4 rounded-lg text-lg font-semibold hover:from-slate-800 hover:to-slate-950 transition-all shadow-xl whitespace-nowrap cursor-pointer"
                >
                  Richiedi Preventivo
                </button>
                <button
                  onClick={() => {
                    const element = document.getElementById('servizi');
                    if (element) element.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-white/20 transition-all border-2 border-white/30 whitespace-nowrap cursor-pointer"
                >
                  Scopri di Più
                </button>
              </div>
            </div>
          </div>
        </div>
      ))}

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 flex space-x-3 z-10">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`w-3 h-3 rounded-full transition-all cursor-pointer ${
              index === currentSlide
                ? 'bg-white w-8'
                : 'bg-white/50 hover:bg-white/75'
            }`}
          />
        ))}
      </div>

      <style>{`
        @keyframes fade-in {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fade-in {
          animation: fade-in 0.8s ease-out;
        }
        .animate-fade-in-delay {
          animation: fade-in 0.8s ease-out 0.2s both;
        }
        .animate-fade-in-delay-2 {
          animation: fade-in 0.8s ease-out 0.4s both;
        }
      `}</style>
    </section>
  );
}